<script setup lang="ts">
import {computed} from 'vue';
import {useStore} from '../store';
import {BlindPosition} from '../types';
import IconClosed from './IconClosed.vue';
import IconOpen from './IconOpen.vue';

const store = useStore();

const tBlindPosition = computed(() => VisualiserConfig.locale === 'au'
    ? 'Blind position'
    : 'Shade Position');

const options = computed(() => [
    {value: BlindPosition.Open, label: 'Open', icon: IconOpen},
    {value: BlindPosition.Closed, label: 'Closed', icon: IconClosed},
]);
</script>

<template>
    <div class="visualiser-controls-main">
        <div class="visualiser-controls-main-label-sm">{{ tBlindPosition }}:</div>
        <div class="visualiser-controls-main-label-lg">{{ tBlindPosition }}</div>
        <div class="visualiser-controls-main-toggle">
            <div
                v-for="{value, label, icon} in options"
                :class="['visualiser-controls-main-toggle-option', store.blindPosition === value && 'active']"
                @click="store.blindPosition = value"
            >
                <div class="visualiser-controls-main-toggle-option-icon">
                    <component :is="icon" />
                </div>
                {{ label }}
            </div>
        </div>
    </div>
</template>
